export default __webpack_public_path__ + "static/media/Ellucian_Sketch_Symbol_Library_02.c9ef730c.jpg";